import liuHeConfig from '@/utils/drawCanvas/liuHeConfig'

// 產生 24524501.com ~ 24524509.com 的隨機網址
export const domainList = Array.from({ length: 9 }, (value, index) => {
  return `2452450${9 - index}.com`
})

/**
 * 從給定的陣列中返回隨機選取的項目。
 *
 * @param {Array} arr - 要從中選取隨機項目的陣列。默認為空陣列。
 * @return {*} - 陣列中隨機選取的項目。如果輸入不是陣列或為空，則返回 `null`。
 */
export const getRandomItem = (arr = []) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return null // 或者抛出错误
  }
  const randomIndex = Math.floor(Math.random() * arr.length)
  return arr[randomIndex]
}

// 回傳介於 min 和 max（包含兩端）的隨機整數
export const getRandomIntegerInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 正碼神準幻境隨機資料
 *
 * @param {Object} vm - DrawCore 的 ViewModel
 * @param {Object} options - 選項
 * @param {number} options.num - 正碼神準幻境隨機資料的隨機數量，默認為 4
 * @param {Array} options.codes - 正碼神準幻境隨機資料的陣列
 * @param {string} options.customPath - 自定義的圖片路徑
 * @return {Object} - 正碼神準幻境隨機資料，包含隨機圖片路徑、隨機數量、正碼神準幻境隨機資料的詳細資料和簡要資料
 */
export const ZhengMaYuCeRandomData = (vm, { num = 4, codes, imagesRoot = 'shared', customPath = '' } = {}) => {
  const randomCode = getRandomItem(codes)
  if (!randomCode) {
    return {
      randomImageUrl: '',
      codeDetail: [],
      codeSummary: ''
    }
  }
  const randomNumber = Math.floor(Math.random() * num) + 1
  let imagePath = ''
  if (customPath) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${customPath}/${randomCode.imgName}-${randomNumber}.jpg`)
  } else if (vm.cpCode) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/zheng-ma-yu-ce/${randomCode.imgName}-${randomNumber}.jpg`)
  }
  console.log('ZhengMaYuCeRandomData imagePath', imagePath)
  return {
    randomImageUrl: imagePath,
    codeDetail: randomCode.codeDetail,
    codeSummary: randomCode.codeSummary
  }
}

/**
 * 正碼總和隨機資料
 *
 * @param {Object} vm - DrawCore 的 ViewModel
 * @param {Object} options - 選項
 * @param {string} options.moveTitle - 正碼總和的標題，默認為 ''
 * @param {Array} options.moves - 正碼總和隨機資料的陣列
 * @param {string} options.customPath - 自定義的圖片路徑
 * @return {Object} - 正碼總和隨機資料，包含隨機圖片路徑、隨機數量、正碼總和隨機資料的詳細資料和簡要資料
 */
export const ZhengMaZongHeRandomData = (vm, { moves = [], imagesRoot = '', customPath = '' } = {}) => {
  const randomMove = getRandomItem(moves)
  if (!randomMove) {
    return {
      backgroundImageStyle: '',
      moveString: '',
      moveDescription: ''
    }
  }
  const moveDescription = randomMove?.desc
  const code = randomMove?.code
  const name = randomMove?.name
  const moveString = `${vm.ZhengMaZongHeData.moveTitle}第${code}式 ${name}`

  let imagePath = ''

  if (customPath) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${customPath}/${randomMove?.imgName}.jpg`)
  } else if (vm.cpCode) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/zheng-ma-zong-he/${randomMove?.imgName}.jpg`)
  }

  vm.$sentry.captureMessage(`${vm.sentryUUID} ZhengMaZongHeRandomData, ${vm.cpCode}, ${vm.period}`, {
    level: 'info',
    extra: {
      randomMove,
      customPath,
      imagePath
    }
  })
  console.log('ZhengMaZongHeRandomData imagePath', imagePath)
  return {
    backgroundImageStyle: imagePath,
    moveString: moveString,
    moveDescription: moveDescription
  }
}

// 取得特碼必中六肖指定 key 資料
export const randomSixZodiac = ({ propData, type, key }) => {
  return getPredictionType({ propData, type, key })
}

// 取得特碼必中六肖指定 key 資料
export const getPredictionType = ({ propData, type, key = '' }) => {
  const predictionGuesses = Array.isArray(propData.prediction_guesses) && propData.prediction_guesses.length > 0 && propData.prediction_guesses
  if (!predictionGuesses) return null
  const findType = predictionGuesses.find((item) => item.predictionType === type) || {}
  return (Object.keys(findType).includes(key) && findType[key]) || []
}

/**
 * 根據傳入參數，取得隨機背景圖的路徑和對應的隨機碼。
 * 支援 liuHe 生肖邏輯，或通用的隨機圖片邏輯。
 *
 * @param {Object} vm - DrawCore 的 Vue 實例
 * @param {Object} options - 選項
 * @param {Object} [options.shengXiaoEnMap] - (六合彩專用) 生肖英文對應的 Map。如果提供此參數，則優先使用生肖邏輯。
 * @param {Array} [options.codes] - (通用邏輯) 包含圖片資訊的陣列，例如 ['a', 'b', 'c']。
 * @param {number} [options.num=5] - 隨機圖片的數量範圍 (從 1 到 num)。
 * @param {string} [options.imagesRoot=''] - 圖片資源的根目錄。
 * @param {string} [options.customPath=''] - 自定義的圖片路徑，優先級高於預設路徑。
 * @returns {{imagePath: string, randomCode: string|null}} - 包含隨機背景圖路徑和隨機碼的物件。
 */
export const TeMaBiZhongLiuXiaoRandomImageStyle = (vm, { shengXiaoEnMap, codes, num = 5, imagesRoot = '', customPath = '' } = {}) => {
  let imageBaseName = ''
  let randomCodeResult = null

  if (shengXiaoEnMap) {
    const getFirstZodiac = Array.isArray(vm.TeMaBiZhongLiuXiaoData.randomSixZodiac) && vm.TeMaBiZhongLiuXiaoData.randomSixZodiac.length > 0 && vm.TeMaBiZhongLiuXiaoData.randomSixZodiac[0]
    if (getFirstZodiac) {
      imageBaseName = shengXiaoEnMap[getFirstZodiac]
      randomCodeResult = getFirstZodiac
    }
  } else if (codes) {
    const randomCode = getRandomItem(codes)
    if (randomCode) {
      imageBaseName = randomCode
      randomCodeResult = randomCode // 保存要回傳的通用碼
    }
  }

  if (!imageBaseName) {
    return { imagePath: '', randomCode: null }
  }

  const randomNumber = Math.floor(Math.random() * num) + 1
  const imageName = `${imageBaseName}-${randomNumber}`

  let imagePath = ''

  if (customPath) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${customPath}/${imageName}.jpg`)
  } else {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/zodiac/${imageName}.jpg`)
  }
  console.log('TeMaBiZhongLiuXiaoRandomImageStyle imagePath', imagePath)
  vm.$sentry.captureMessage(`${vm.sentryUUID} TeMaBiZhongLiuXiaoRandomImageStyle, ${vm.cpCode}, ${vm.period}`, {
    level: 'info',
    extra: {
      TeMaBiZhongLiuXiaoData: vm.TeMaBiZhongLiuXiaoData,
      imageBaseName,
      randomNumber,
      customPath,
      num,
      imagePath,
      expectImageName: imageName
    }
  })
  return { imagePath, randomCode: randomCodeResult }
}

/**
 * 武器兵器隨機資料
 *
 * @param {Object} vm - DrawCore 的 ViewModel
 * @param {Object} options - 選項
 * @param {Array} options.tools - 武器兵器資料的陣列
 * @param {string} options.customPath - 自定義的圖片路徑
 * @return {Object} - 武器兵器隨機資料，包含隨機圖片路徑，圖片數量 對應 資料數量
 **/
export const WeaponRandomData = (vm, { tools = [], imagesRoot = '', customPath = '' } = {}) => {
  const randomData = getRandomItem(tools)
  if (!randomData) {
    return {
      blockTitle: vm.WeaponData.blockTitle,
      randomData: {},
      randomImageUrl: ''
    }
  }
  let imagePath = ''
  if (Object.keys(randomData).length === 0) return {}
  if (customPath) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${customPath}/${randomData?.imgName}.png`)
  } else if (vm.cpCode) {
    imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/weapon/${randomData?.imgName}.png`)
  }
  vm.$sentry.captureMessage(`${vm.sentryUUID} WeaponRandomData, ${vm.cpCode}, ${vm.period}`, {
    level: 'info',
    extra: {
      randomData,
      customPath,
      imagePath
    }
  })
  console.log('WeaponRandomData imagePath', imagePath)
  return {
    blockTitle: vm.WeaponData.blockTitle,
    randomData,
    randomImageUrl: imagePath
  }
}

/**
 * 波色預測隨機背景圖
 *
 * @param {Object} vm - DrawCore 的 ViewModel
 * @param {Object} options - 選項
 * @param {string} options.customPath - 自定義的圖片路徑
 * @return {Object} - 波色預測隨機背景圖，包含隨機圖片路徑
 */
export const BoSeYuCBackgroundImageStyle = (vm, { num = 12, imagesRoot = '', customPath = '', imageName = '' } = {}) => {
  const randomNumber = getRandomIntegerInRange(1, num)

  const pathSegment = `${imageName && imageName.toLowerCase() + '-'}`
  const imagePath = customPath
    ? require(`@/draw-core/assets/images/${imagesRoot}/${customPath}/${pathSegment}${randomNumber}.jpg`)
    : require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/bo-se-yu-ce/${pathSegment}${randomNumber}.jpg`)
  vm.$sentry.captureMessage(`${vm.sentryUUID} WeaponRandomData, ${vm.cpCode}, ${vm.period}`, {
    level: 'info',
    extra: {
      randomNumber,
      customPath,
      imagePath
    }
  })
  console.log('BoSeYuCBackgroundImageStyle imagePath', imagePath)
  return {
    imagePath
  }
}

// 隨機 footer 圖
export const randomFooterImage = (vm, { num = 1, imagesRoot = '' }) => {
  const randomNumber = getRandomIntegerInRange(1, num)
  const imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/footer-image/${randomNumber}.png`)
  console.log('randomFooterImage imagePath', imagePath)
  return imagePath
}

// 圖庫隨機背景圖
export const randomPaperBackgroundImage = (vm, { num = 1, imagesRoot = '' }) => {
  const randomNumber = getRandomIntegerInRange(1, num)
  const imagePath = require(`@/draw-core/assets/images/${imagesRoot}/${vm.cpCode}/background/${randomNumber}.jpg`)
  console.log('randomPaperBackgroundImage imagePath', imagePath)
  return imagePath
}

// 特碼走勢隨機圖表資料
export const randomTeMaZouShiShengXiao = (data = []) => {
  const randomData = getRandomItem(data) || {}
  const { label = [], shengXiao = [], blockTitle = '' } = randomData
  return {
    shengXiaoCategories: shengXiao,
    categoriesOrderList: label,
    blockTitle
  }
}

// 隨機策略資料
export const randomeBuGuaCeLueGram = (data = []) => {
  return getRandomItem(data) || {}
}

// 圖庫 api 請求處理
export const paperFetchHandler = (requestFn, {
  beforeRequest = null,
  processData = null,
  afterRequest = null,
  errorHandler = null,
  returnResult = false, // 控制是否返回結果
  expectPair = true // 新增參數，標記是否期望 [data, error] 格式
} = {}) => {
  return async(...args) => {
    try {
      // 請求前處理
      if (typeof beforeRequest === 'function') {
        const beforeResult = await beforeRequest(...args)
        // 如果 beforeRequest 返回特定值，可以提前結束並回傳
        if (beforeResult === false) {
          return { success: false, data: null, error: '被 beforeRequest 取消' }
        }
      }

      let data, error
      if (expectPair) {
        // 原有邏輯，期望返回 [data, error] 格式
        [data, error] = await requestFn(...args)

        if (error) {
          throw error
        }
      } else {
        // 新增邏輯，處理 Promise 直接返回的情況
        try {
          data = await requestFn(...args)
          error = null
        } catch (e) {
          error = e
          throw error
        }
      }

      let processedData = data
      // 數據處理
      if (typeof processData === 'function') {
        processedData = await processData(data, ...args) || data
      }

      // 請求後處理
      if (typeof afterRequest === 'function') {
        await afterRequest(processedData, ...args)
      }

      // 根據 returnResult 決定返回值
      return returnResult
        ? { success: true, data: processedData, error: null }
        : true
    } catch (error) {
      if (typeof errorHandler === 'function') {
        await errorHandler(error, requestFn.name, ...args)
        console.error('errorHandler:', error)
      } else {
        console.error(`请求失败 (${args.join(', ')}):`, error)
      }

      // 根據 returnResult 決定返回值
      return returnResult
        ? { success: false, data: null, error }
        : false
    }
  }
}

export const calculateCategoryRatio = (data) => {
  // 檢查輸入是否為陣列
  if (!Array.isArray(data)) {
    return null
  }

  // 檢查陣列是否為空
  if (data.length === 0) {
    return { categories: {}, total: 0 }
  }

  // 計算每個類別的數量
  const categoryCount = {}
  const total = data.length

  data.forEach(item => {
    if (item && item.category) {
      if (categoryCount[item.category]) {
        categoryCount[item.category]++
      } else {
        categoryCount[item.category] = 1
      }
    } else {
      console.error('無效的資料項目', item)
    }
  })

  // 計算每個類別的比例
  const result = {
    categories: {},
    total: total
  }

  for (const category in categoryCount) {
    const count = categoryCount[category]
    const ratio = count / total
    result.categories[category] = {
      count: count,
      ratio: ratio,
      percentage: (ratio * 100).toFixed(2) + '%'
    }
  }

  return result
}
/**
 * 重試或輪詢一個操作，直到成功或達到最大嘗試次數
 * @param {Function} operation - 要執行的操作函數，應返回一個Promise
 * @param {Array} operationArgs - 傳給operation函數的參數數組
 * @param {Function} isSuccessful - 判斷操作是否成功的函數，接收operation的結果作為參數
 * @param {number} maxAttempts - 最大嘗試次數，預設為10
 * @param {number} delaySeconds - 每次嘗試間的延遲秒數，預設為10
 * @returns {Promise} - 返回最後一次操作的結果
 */
export async function retryOrPollUntil({
  operation,
  operationArgs = [], // 新增：傳給operation的參數數組
  isSuccessful = (result) => !!result,
  maxAttempts = 10,
  delaySeconds = 10,
  getIsCancelled = () => false,
  pollRef = {}
}) {
  // Cancel any previous timer associated with this ref
  if (pollRef.cancel) {
    pollRef.cancel()
  }

  let attempts = 0
  let lastResult

  while (attempts < maxAttempts) {
    if (getIsCancelled()) {
      break
    }
    attempts++

    try {
      // 使用展開運算符(...operationArgs)將參數數組傳遞給operation函數
      lastResult = await operation(...operationArgs)

      // 檢查操作是否成功
      if (isSuccessful(lastResult)) {
        if (pollRef.cancel) pollRef.cancel = null
        return lastResult
      }
    } catch (error) {
      // ignored
    }

    // 如果達到最大嘗試次數，則不再等待
    if (attempts >= maxAttempts) {
      break
    }

    // 等待指定的延遲時間
    const waitPromise = new Promise((resolve, reject) => {
      const timeoutId = setTimeout(resolve, delaySeconds * 1000)

      // The cancellation function for this specific wait
      pollRef.cancel = () => {
        clearTimeout(timeoutId)
        // Reject the promise to break the await
        reject(new Error('Polling cancelled by new call.'))
      }
    })

    try {
      await waitPromise
    } catch (error) {
      // This will catch the rejection from pollRef.cancel()
      if (error.message === 'Polling cancelled by new call.') {
        console.error(error.message)
        // Break the loop because we've been cancelled.
        break
      }
      // Re-throw other errors
      throw error
    } finally {
      // Clean up the cancel function for this wait
      pollRef.cancel = null
    }
  }
  return lastResult
}

// showImage 共用切換期數輪詢檢查
export const paperPollingRefCancel = function(vm) {
  if (vm.$store?.state?.lottery?.paperPollingRef?.cancel) {
    vm.$store.state.lottery.paperPollingRef.cancel()
  }
  vm.$store.dispatch('lottery/setPollingCancelledForPeriod', vm.currentPeriod)
}

export const fetchDataErrorText = '图片加载失败，请刷新页面'
export const chartFontFamily = '"Noto Sans SC", "PingFang SC", "Apple LiGothic Medium", "Droid Sans", "Microsoft YaHei", "Microsoft JhengHei", "Helvetica Neue", Helvetica, sans-serif'
export const chartEmojiFontFamily = '"Noto Color Emoji", "PingFang SC", "Apple LiGothic Medium", "Droid Sans", "Microsoft YaHei", "Microsoft JhengHei", "Helvetica Neue", Helvetica, sans-serif'

// 取得彩球號碼對應顏色
export const getTeMaBallColor = (num) => {
  switch (num) {
    case 1:
    case 2:
    case 7:
    case 8:
    case 12:
    case 13:
    case 18:
    case 19:
    case 23:
    case 24:
    case 29:
    case 30:
    case 34:
    case 35:
    case 40:
    case 45:
    case 46:
      return 'red'
    case 3:
    case 4:
    case 9:
    case 10:
    case 14:
    case 15:
    case 20:
    case 25:
    case 26:
    case 31:
    case 36:
    case 37:
    case 41:
    case 42:
    case 47:
    case 48:
      return 'blue'
    case 5:
    case 6:
    case 11:
    case 16:
    case 17:
    case 21:
    case 22:
    case 27:
    case 28:
    case 32:
    case 33:
    case 38:
    case 39:
    case 43:
    case 44:
    case 49:
      return 'green'
    default:
      return ''
  }
}

export const commonHandler = (store, vm = null) => {
  return {
    errorHandler: (error, fnName, ...args) => {
      store.dispatch('lottery/setPaperFetchMessage', fetchDataErrorText)
      if (vm?.$sentry) {
        vm.$sentry.captureMessage(`${vm.sentryUUID} API_ERROR, ${vm.cpCode}, ${vm.period}`, {
          level: 'error',
          extra: {
            fnName,
            args,
            errorMessage: error?.message || String(error),
            httpStatus: error?.response?.status || null,
            apiPath: error?.config?.url || null
          }
        })
      }
    },
    returnResult: false
  }
}

// 球顏色對應圖片
const ballBgImages = {
  red: require(`@/draw-core/assets/images/liuHe/ball-bg-red.svg`),
  green: require(`@/draw-core/assets/images/liuHe/ball-bg-green.svg`),
  blue: require(`@/draw-core/assets/images/liuHe/ball-bg-blue.svg`)
}

// 取得球顏色對應圖片
export const getBallImage = (color) => {
  return ballBgImages[color] || ''
}
// Fisher-Yates 洗牌演算法
// 預設 1 ~ 49 取 5 個
export const getRandomNumbersFisher = ({ min = 1, max = 49, count = 5 } = {}) => {
  // 參數驗證
  if (min > max) {
    throw new Error('最小值不能大於最大值')
  }
  if (count > (max - min + 1)) {
    throw new Error('取得數量不能超過範圍內的總數量')
  }
  if (count <= 0) {
    throw new Error('取得數量必須大於0')
  }

  const range = max - min + 1
  const numbers = Array.from({ length: range }, (_, i) => i + min)

  for (let i = 0; i < count; i++) {
    const randomIndex = getRandomIntegerInRange(i, range - 1);
    [numbers[i], numbers[randomIndex]] = [numbers[randomIndex], numbers[i]]
  }

  return numbers.slice(0, count).sort((a, b) => a - b)
}

// SSC 專用: 0-9 隨機取 5 個，可重複
export const getRandomNumbersSSC = ({ count = 5 } = {}) => {
  return Array.from({ length: count }, () => Math.floor(Math.random() * 10))
}

// 報紙產圖彩種分類: 單一資料來源
export const newspaperTypeMapping = {
  liuHe: ['am6', 'amsf6', 'amwf6', 'amff6', 'js6', 'sf6', 'ff6'],
  pk10: ['wfpk10', 'jspk10'],
  ssc: ['wfssc', 'jsssc'],
  '11x5': []
}

// 報紙出圖彩種分類清單 (從 newspaperTypeMapping 衍生，以維持向下相容)
export const newspaperListInfo = Object.entries(newspaperTypeMapping).reduce(
  (acc, [cpType, lotteryCodes]) =>
    acc.concat(lotteryCodes.map(lotteryCode => ({ lotteryCode, cpType }))),
  []
)

// 彩種代碼對應分類的 Map
export const newspaperCodeToTypeMap = newspaperListInfo.reduce((obj, item) => {
  obj[item.lotteryCode] = item.cpType
  return obj
}, {})

// 報紙產圖彩種清單過濾
/**
 * 產生彩種清單，cp168 為所有彩種，marksix168 剔除 PK10、SSC、11x5 彩紙產圖
 * @returns {Array}
 */
export const newspaperListInfoMap = () => {
  if (liuHeConfig.appName === 'cp168') {
    // 直接從 mapping 中攤平所有彩種
    return Object.values(newspaperTypeMapping).flat()
  }
  // marksix168 只回傳 liuHe 類型的彩種
  return newspaperTypeMapping.liuHe
}

// 六合彩報紙產圖清單 (使用新的 newspaperListInfoMap)
export const newspaperList = newspaperListInfoMap()

// 不需要處理 TeMaZouShiData (生肖家野、生肖天地、男女肖) 的彩種
export const excludeTeMaZouShiDataList = ['amff6', 'js6', 'sf6', 'ff6']

// 控制 Bar chart 和 line chart 延後渲染
export const watchChartDataRenderHandler = (vm, { newVal, oldVal, key = '', time = 100 }) => {
  if (newVal && newVal.datasets && newVal.datasets[0].data.length > 0) {
    vm.$nextTick(() => {
      // 重新渲染圖表
      vm[key] = false
      setTimeout(() => {
        vm[key] = true
      }, time)
    })
  }
}

// 圖庫彩種選單名稱
export const cpsDetail = function(vm, cpType) {
  if (!vm || !vm.$store) {
    console.error('cpsDetail function requires a Vue instance with a $store property.')
    return {}
  }
  const mapping = {
    liuHe: {
      detail: vm.$store.state.lottery.liuHeDetail
    },
    pk10: {
      detail: vm.$store.state.lottery.pk10Detail
    },
    ssc: {
      detail: vm.$store.state.lottery.sscDetail
    }
  }
  return mapping[cpType]?.detail || {}
}

// 圖片載入狀態檢查與 sentry 追蹤
export const elementCheckRecord = (vm) => {
  console.log('=== elementCheckRecord ===');
  if (!vm) return
  console.log('vm.paperElementsCheckListMap :>> ', vm.paperElementsCheckListMap);
  const allElementsLoaded = vm.paperElementsCheckListMap.every(item => item.loaded)
  vm.$sentry.captureMessage(`${vm.sentryUUID}, paperElementsCheckListMap, ${allElementsLoaded}, ${vm.cpCode}, ${vm.period}`, {
    level: 'info',
    extra: {
      components: `${JSON.stringify(vm.paperElementsCheckListMap, null, 2)}`
    }
  })
  console.log('allElementsLoaded ========> ', allElementsLoaded)
  vm.$store.dispatch('lottery/setShouldTriggerImageUpload', allElementsLoaded)
}

// 執行時間
export const executionTimer = () => {
  let startTime = null
  let executionTime = null

  return {
    start: function() {
      startTime = Date.now()
    },
    end: function() {
      if (startTime === null) {
        throw new Error('請先呼叫 start()')
      }
      executionTime = Date.now() - startTime
      return executionTime
    },
    getTime: function() {
      return executionTime
    }
  }
}

// 彩種元件共用 props
export const imagesPropsCommon = {
  period: {
    type: String,
    required: true,
    default: () => ''
  },
  cpId: {
    type: Number,
    required: true,
    default: () => null
  },
  cpCode: {
    type: String,
    required: true,
    default: () => ''
  },
  periodData: {
    type: Array,
    default: () => []
  },
  isActivePeriod: {
    type: Object,
    default: () => ({
      index: 0
    })
  },
  nextPeriod: {
    type: Function,
    default: () => {}
  },
  previousPeriod: {
    type: Function,
    default: () => {}
  }
}

// 彩種元件共用 provide/inject
export const provideInjectCommon = {
  inject: ['provideCptypeData'],
  provide() {
    return {
      provideComponentData: () => this.componentData
    }
  }
}
